import { create } from 'zustand';
import { Restaurant } from '@/types/restaurant';
import { Meta } from '@/lib/types/customer/RestaurantJobs';

type RestaurantsData = {
  data: Restaurant[];
  meta: Meta;
};

type State = {
  isLoading: boolean;
  restaurantsData: RestaurantsData;
  isMoreLoading: boolean;
  hasMore: boolean;
  currentPage: number;
};

type Actions = {
  setData: (data: RestaurantsData) => void;
  setLoading: () => void;
  setIsLoading: (isLoading: boolean) => void;
  setIsMoreLoading: (value: boolean) => void;
  setCurrentPage: (page: number) => void;
  setHasMore: (value: boolean) => void;
};

export const useRestaurantStore = create<State & Actions>((set) => ({
  restaurantsData: {
    data: [],
    meta: {
      current_page: 1,
      from: 1,
      last_page: 1,
      links: [],
      path: '',
      per_page: 3,
      to: 3,
      total: 3,
    },
  },
  isLoading: false,
  isMoreLoading: false,
  hasMore: false,
  currentPage: 1,

  setData: (data: RestaurantsData) => {
    set({ restaurantsData: data, isLoading: false });
  },
  setLoading: () => {
    set({ isLoading: true });
  },
  setIsLoading: (isLoading) => {
    set({ isLoading });
  },
  setCurrentPage: (page) => {
    set({ currentPage: page });
  },
  setHasMore: (value) => {
    set({ hasMore: value });
  },
  setIsMoreLoading: (value) => {
    set({ isMoreLoading: value });
  },
}));
